<template>
  <main class="page">
    <AppBack />
    <section class="section page__header">
      <h1 class="title">Создать сотрудника</h1>
    </section>

    <div class="form__bg">
    <Form @request="createUser" ref="form">
        <section class="section">
          <h2 class="subtitle">Укажите учетные данные сотрудника</h2>
          <AppParagraph>
            Все поля обязательны для заполнения!
          </AppParagraph>
          <AppParagraph>
            Пароль должен быть не короче шести символов, содержать как минимум
            одну строчную и одну прописную букву.
          </AppParagraph>
          <div class="form__inputs" style="margin-top: 20px">
            <VInput
              label="E-mail"
              email
              name="email"
              required
              :disabled="isCreating"
            >
              <Validation for="email">Введите адрес электронной почты</Validation>
              <Validation for="required">Это поле является обязательным</Validation>
            </VInput>
            <VInput
              label="Телефон*"
              name="phone"
              required
              minLength="11"
              maskRegex="7##########"
              :disabled="isCreating"
            >
              <Validation for="required">Это поле является обязательным</Validation>
              <Validation for="minLength">Введите номер мобильного телефона</Validation>
            </VInput>
            <VInput :disabled="isCreating" label="Имя" name="name" />
            <VInput :disabled="isCreating" label="Фамилия" name="surname" />
            <AppSelect
              title="Роль сотрудника"
              placeholder="Выберите роль сотрудника"
              :disabled="isCreating"
              :value="{ id: 2, name: 'Рабочий' }"
              :options="usersRoleOptions"
              name="roles"
            />
            <p></p>
            <VInput
              v-model="password"
              label="Пароль*"
              type="password"
              name="password"
              required
              pattern="(?=^.{6,}$)((?=.*\d)|(?=.*\W+))(?![.\n])(?=.*[A-Z])(?=.*[a-z]).*$"
              :disabled="isCreating"
            >
              <Validation for="required">Это поле является обязательным</Validation>
              <Validation for="pattern">Пароль должен состоять из строчных и прописных латинских букв, цифр и не менее 6 символов</Validation>
            </VInput>
            <VInput
              label="Подтвердите пароль*"
              :sameAs="password"
              type="password"
              name="password_confirmation"
              required
              :disabled="isCreating"
            >
              <Validation for="required">Это поле является обязательным</Validation>
              <Validation for="sameAs">Пароли не совпадают</Validation>
            </VInput>
          </div>
      </section>

        <section class="section" style="margin-top: 32px">
          <div class="page__buttons">
            <div class="page__item">
              <AppButton title="Cоздать" type="main" :disabled="isCreating" />
            </div>
            <div class="page__item">
              <AppButton
                title="Отмена"
                type="alt"
                :disabled="isCreating"
                @click.native="leavePage"
              />
            </div>
          </div>
        </section>

      </Form>
    </div>

    <transition name="fade">
      <AppModal
        v-if="modalActive.success"
        title="Сотрудник успешно создан!"
        text="Перейти к заполнению подробной информации о сотруднике?"
        confirm-button-type="main"
        confirm-button-title="Да"
        @confirm="editCreatedUser"
        reject-button-type="alt"
        reject-button-title="Нет"
        @reject="closeModal"
      />
      <AppModal
        v-if="modalActive.error"
        title="Ошибка!"
        text="Вернутся к созданию сотрудника"
        confirm-button-type="main"
        confirm-button-title="ОК"
        @confirm="closeModal"
      />
    </transition>
  </main>
</template>

<script>
import AppButton from '../../components/page/button/AppButton'
import AppParagraph from '../../components/page/text/AppParagraph'
import AppModal from '../../components/page/modal/AppModal'
import AppSelect from '@/components/page/input/AppSelect'
import { mapGetters } from 'vuex'

import Form from '@/components/page/Form/Form.vue'
import VInput from '@/components/page/Form/Vinput/Vinput.vue'
import Validation from '@/components/page/Form/Validation.vue'
import AppBack from '@/components/page/AppBack'

export default {
  components: {
    AppSelect,
    AppModal,
    AppParagraph,
    AppButton,
    AppBack,
    Form,
    VInput,
    Validation
  },
  data () {
    return {
      password: ''
    }
  },
  computed: {
    ...mapGetters({
      usersRoleOptions: '[dictionaries] usersRoleList',
      modalActive: 'userCreatePageModals',
      isCreating: 'userCreateIsCreating'
    }),
    passwordConfirmed () {
      return !(this.validation.confirmedPassword.type === 'success')
    }
  },
  methods: {
    loadOptions () {
      this.$store.dispatch('[dictionaries] getRoleList')
    },
    createUser (data) {
      this.$store.dispatch('createUser', data)
    },
    editCreatedUser () {
      const userId = this.$store.getters.getCreatedUser.id
      this.$store.dispatch('closeUserCreateModal')
      this.$router.push({ path: `/user/update/${userId}` })
    },
    leavePage () {
      this.$store.dispatch('closeUserCreateModal')
      this.$router.push({ path: '/user/list' })
    },
    closeModal () {
      this.$store.dispatch('closeUserCreateModal')
    }
  },
  mounted () {
    this.loadOptions()
  },
  watch: {
    'modalActive.success' (val) {
      if (val) this.$refs.form.clear()
    }
  }
}
</script>

<style></style>
